import { FormLabel, VFlow } from 'bold-ui'
import { RadioGroupField } from 'components/form'
import { CiapSelectField } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectField } from 'components/form/field/select/CidSelectField/CidSelectField'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { CiapCapituloEnum, SexoEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel, TipoMotivoPrescricaoEnum } from '../../../model-prescricao'

export interface MotivoPrescricaoSectionProps {
  name: MetaRoot<MedicamentoFormModel>
  podeRegistrarCid: boolean
  sexoCidadao: SexoEnum | null
  idadeCidadaoEmAnos?: number
}

export const MotivoPrescricaoSection = React.memo((props: Readonly<MotivoPrescricaoSectionProps>) => {
  const { name, podeRegistrarCid, sexoCidadao, idadeCidadaoEmAnos } = props

  const { input: tipoMotivoInput } = usePecField({
    name: name.tipoMotivoPrescricao.absolutePath(),
    subscription: { value: true },
  })

  const tipoMotivoPrescricao = tipoMotivoInput.value as TipoMotivoPrescricaoEnum

  return (
    <VFlow vSpacing={0}>
      {podeRegistrarCid ? (
        <RadioGroupField
          name={name.tipoMotivoPrescricao.alias}
          label='Motivo da prescrição'
          options={[
            { value: TipoMotivoPrescricaoEnum.CID10, label: 'CID10' },
            { value: TipoMotivoPrescricaoEnum.CIAP2, label: 'CIAP2' },
          ]}
        />
      ) : (
        <FormLabel label='Motivo da prescrição' />
      )}

      {tipoMotivoPrescricao === TipoMotivoPrescricaoEnum.CID10 && podeRegistrarCid ? (
        <CidSelectField
          name={name.cidMotivoPrescricao.alias}
          label='CID10'
          renderGrupoCiapRelacionada={false}
          sexo={sexoCidadao}
          idadeCidadaoEmAnos={idadeCidadaoEmAnos}
          required
        />
      ) : (
        <CiapSelectField
          name={name.ciapMotivoPrescricao.alias}
          label='CIAP2'
          sexo={sexoCidadao}
          idadeCidadaoEmAnos={idadeCidadaoEmAnos}
          capitulosExcluidos={[CiapCapituloEnum.PROCEDIMENTOS]}
          excluirCIAPsDAB
          required
        />
      )}
    </VFlow>
  )
})
